import { useYear } from "../context/YearContext";
import { Calendar } from "lucide-react";

const YearSwitcher = ({ className = "" }) => {
  const { year, setYear, availableYears } = useYear();

  return (
    <div
      data-testid="year-switcher"
      className={`inline-flex items-center gap-2 bg-white border rounded-lg p-1 ${className}`}
    >
      <Calendar className="w-4 h-4 text-slate-400 ml-2" />
      <span className="text-xs uppercase font-bold text-slate-500 mr-1">Año:</span>
      {availableYears.map((y) => (
        <button
          key={y}
          data-testid={`year-btn-${y}`}
          onClick={() => setYear(y)}
          className={`px-3 py-1 rounded-md text-sm font-semibold transition-colors ${
            year === y
              ? "bg-blue-600 text-white shadow"
              : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          {y}
        </button>
      ))}
    </div>
  );
};

export default YearSwitcher;
